import React from "react";
import './Divider.css';

const Divider = () => <div className="divider" />

export default Divider;